import { map, uniq } from "lodash";

const initialState = {
  emails: {
    ids: [],
    isFetching: false,
    pageCount: 0,
    filters: {},
  },
  emailModules: {
    ids: [],
    isFetching: false,
    pageCount: 0,
    filters: {},
  },
  emailTemplates: {
    ids: [],
    isFetching: false,
    pageCount: 0,
    filters: {},
  },
  images: {
    ids: [],
    isFetching: false,
    pageCount: 0,
    filters: {},
  },
  campaigns: {
    ids: [],
    isFetching: false,
    pageCount: 0,
    filters: {},
  },
  campaignsByParent: {},
};

export default function pagination(state = initialState, action) {
  if (action.list && action.fetching) {
    if (action.subList) {
      return Object.assign({}, state, {
        [action.list]: Object.assign({}, state[action.list], {
          [action.subList]: Object.assign(
            {},
            state[action.list],
            {
              isFetching: true,
            },
            action.reset
              ? {
                  ids: [],
                }
              : undefined
          ),
        }),
      });
    } else {
      // Mark as fetching
      return Object.assign({}, state, {
        [action.list]: Object.assign(
          {},
          state[action.list],
          {
            isFetching: true,
          },
          action.reset
            ? {
                ids: [],
              }
            : undefined
        ),
      });
    }
  } else if (
    action.entity &&
    action.list &&
    action.data &&
    Array.isArray(action.data)
  ) {
    const listState = action.subList
      ? state[action.list][action.subList]
      : state[action.list];

    // Got response
    const currentState =
      action.reset || !state[action.list]
        ? // If reset state
          {
            ids: [],
            filters: {},
            pageCount: 0,
            isFetching: false,
          }
        : // Current State
          listState;

    const updatedState = Object.assign(currentState, {
      nextPageUrl: action.nextPageUrl,
      pageCount: currentState.pageCount + 1,
      isFetching: false,
      filters: Object.assign({}, currentState.filters, action.filters),
      ids: uniq([].concat(currentState.ids, map(action.data, "id"))),
    });

    if (action.subList) {
      return Object.assign({}, state, {
        [action.list]: Object.assign({}, state[action.list], {
          [action.subList]: updatedState,
        }),
      });
    } else {
      return Object.assign({}, state, {
        [action.list]: updatedState,
      });
    }
  }

  return state;
}
